import { Container, Title, Text, Button, Group } from "@mantine/core";
import classes from "./globalError.module.css";
import { useNavigate } from "react-router-dom";

const GlobalError = () => {
  const navigate = useNavigate();
  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.label}>500</div>
        <Title className={classes.title}>Something bad just happened...</Title>
        <Text size="lg" className={classes.description}>
          Our servers could not handle your request. Don&apos;t worry, our
          development team was already notified. Try refreshing the page or
        </Text>
        <Group position="center">
          <Button
            size="md"
            onClick={() => {
              navigate("/");
              navigate(0);
            }}
          >
            Back to Home
          </Button>
          <Button
            size="md"
            onClick={() => {
              navigate("/add-issue");
              navigate(0);
            }}
          >
            Contact Support
          </Button>
        </Group>
      </Container>
    </div>
  );
};

export default GlobalError;
